var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ErrorHandler } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';
var CustomErrorHandler = /** @class */ (function (_super) {
    __extends(CustomErrorHandler, _super);
    function CustomErrorHandler(errorTracking) {
        var _this = _super.call(this) || this;
        _this.errorTracking = errorTracking;
        return _this;
    }
    CustomErrorHandler.prototype.handleError = function (error) {
        this.errorTracking.captureException(error);
        _super.prototype.handleError.call(this, error);
    };
    return CustomErrorHandler;
}(ErrorHandler));
export { CustomErrorHandler };



// WEBPACK FOOTER //
// ./src/@freelancer/tracking/custom-error-handler.service.ts.pre-build-optimizer.js